import * as React from 'react';
import { Text } from '@grandvisionhq/elements';

const SolutionSpecs = ({ type , volume , labels  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, type, ", "), /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, volume, " ", labels.unit))
;

export { SolutionSpecs };
//# sourceMappingURL=SolutionSpecs.js.map
